import Firebase from 'firebase/app'
import credentials from '@/firebase/credentials'

export const App = Firebase.initializeApp(credentials.config)

